<template>
    <div>
        <accessComponentVue></accessComponentVue>
    </div>
</template>

<script>
import accessComponentVue from '@/components/Admin/Component/AccessComponent/accessComponent.vue';
export default {
    name: 'PadmawebAccessView',

    data() {
        return {
            
        };
    },

    mounted() {
        
    },

    methods: {
        
    },
    components:{
        accessComponentVue
    }
};
</script>

<style lang="scss" scoped>

</style>